import { LangPrefixType, LocaleType } from "trans"


export function getLocaleTwoLetters(locale: LocaleType): LangPrefixType {
    switch (locale) {
        case "sk_SK":
            return 'sk'
        case "en_GB":
            return 'en'
        case "pl_PL":
            return 'pl'
        case "hu_HU":
            return 'hu'
        case "cs_CZ":
        default:
            return 'cz'
    }
}

export const DATABASE_DATE_FORMAT = "YYYY-MM-DD"
export function getDatePattern(locale: LocaleType): string {
    switch (locale) {
        case "en_GB":
            return 'YYYY-MM-DD'
        case "hu_HU":
            return 'YYYY. MM. DD.'
        case "cs_CZ":
        case "sk_SK":
        case "pl_PL":
        default:
            return 'DD. MM. YYYY'
    }
}

/** adds leading zeros */
export function pad(num: string, size: number): string {
    while (num.length < size) num = "0" + num
    return num
}

export function parseDate(dateString: string, patternString: string, strict: boolean = false): Date | null {
    const parsedValue = dateString.split(/\D+/)
    const parsedPattern = patternString.split(/[^YMD]+/)

    const yearIndex = parsedPattern.findIndex(s => s.includes('Y'))
    const monthIndex = parsedPattern.findIndex(s => s.includes('M'))
    const dayIndex = parsedPattern.findIndex(s => s.includes('D'))

    if (!parsedValue[yearIndex] || !parsedValue[monthIndex] || !parsedValue[dayIndex]) {
        return null
    }

    if (strict && (parsedValue[yearIndex].length < 4 || parsedValue[monthIndex].length < 2 || parsedValue[dayIndex].length < 2)) {  //incomplete
        return null
    }

    const year = parseInt(parsedValue[yearIndex])
    const month = parseInt(parsedValue[monthIndex])
    const day = parseInt(parsedValue[dayIndex])

    if (year < 2000 || year > 3000 || month > 12 || day > 31 || day < 1 || month < 1 || (month === 2 && day > 29)) {
        return null
    }

    let date = new Date()

    date.setFullYear(year)
    date.setMonth(month - 1)  //0 to 11 range!!!
    date.setDate(day)

    return date
}

export function dateToDBFormat(d: Date): string | null {
    if (!d) {
        return null
    }
    //date.setMonth(month - 1)  //0 to 11 range!!!
    return pad(`${d.getFullYear()}`, 4) + '-' + pad(`${d.getMonth() + 1}`, 2) + '-' + pad(`${d.getDate()}`, 2)
}

export function isValidDate(dateString: string, datePattern: string): boolean {
    if (!dateString) {
        return true
    }

    const pattern = datePattern
        .replace('YYYY', '((?:19|20)\\d\\d)')
        .replace('MM', '(0?[1-9]|1[012])')
        .replace('DD', '([12][0-9]|3[01]|0?[1-9])')
        .replace('.', '\.')
        .replace('-', '\-')

    const regex = new RegExp(pattern)
    return regex.test(dateString)

    return true
}
